"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var aes_1 = __importDefault(require("crypto-js/aes"));
var enc_utf8_1 = __importDefault(require("crypto-js/enc-utf8"));
var json_stringify_safe_1 = __importDefault(require("json-stringify-safe"));
var lz_string_1 = __importDefault(require("lz-string"));
var redux_persist_1 = require("redux-persist");
function createCompressEncryptTransform(config) {
    if (!config)
        throw new Error(createErrorMessage("missing config object"));
    var secretKey = config.secretKey, onError = config.onError;
    if (!secretKey || typeof secretKey !== 'string')
        throw new Error(createErrorMessage("missing secret key from config"));
    if (onError && typeof onError !== 'function')
        throw new Error(createErrorMessage("onError has to be a function"));
    return redux_persist_1.createTransform(createInboundTransform(config), createOutboundTransform(config), config);
}
exports.default = createCompressEncryptTransform;
var createInboundTransform = function (config) { return function (state) {
    var secretKey = config.secretKey, onError = config.onError;
    try {
        if (state == undefined) {
            return state;
        }
        var stringifiedState = json_stringify_safe_1.default(state);
        var compressedState = lz_string_1.default.compressToBase64(stringifiedState);
        return aes_1.default.encrypt(compressedState, secretKey).toString();
    }
    catch (e) {
        e.message = createErrorMessage("error during persist transformation: " + e.message);
        onError ? onError(e) : console.error(e);
        return state;
    }
}; };
var createOutboundTransform = function (config) { return function (state) {
    var secretKey = config.secretKey, onError = config.onError;
    if (typeof state !== "string") {
        var e = new Error(createErrorMessage("expected outbound state to be a string"));
        onError ? onError(e) : console.error(e);
        return state;
    }
    try {
        var decryptedStateString = aes_1.default.decrypt(state, secretKey).toString(enc_utf8_1.default);
        var decompressedState = lz_string_1.default.decompressFromBase64(decryptedStateString);
        return JSON.parse(decompressedState);
    }
    catch (e) {
        e.message = createErrorMessage("error during state reconstruction: " + e.message);
        onError ? onError(e) : console.error(e);
        return state;
    }
}; };
var createErrorMessage = function (msg) { return "redux-persist-transform-compress-encrypt:: " + msg; };



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-persist-transform-compress-encrypt/dist/index.js
// module id = 247
// module chunks = 0